import quoteEvergreenBgMobile from "app/assets/quote_patterns/quote-evergreen-bg-mobile.png"
import quoteGeometricBgMobile from "app/assets/quote_patterns/quote-geometric-bg-mobile.png"
import quoteLeavesBgMobile from "app/assets/quote_patterns/quote-leaves-bg-mobile.png"
import quoteOceanBgMobile from "app/assets/quote_patterns/quote-ocean-bg-mobile.png"
import quoteWaveBgMobile from "app/assets/quote_patterns/quote-wave-bg-mobile.png"
import React from "react"
import { twMerge } from "tailwind-merge"

import AnimatedSection from "../../ProProfileShared/AnimatedSection"
import { DEFAULT_HIGHLIGHT_CLASSES } from "../WebsiteBuilderV2Page"

const QuoteSectionMobile = ({ section, theme, highlightedField }) => {
  const isHighlighted = highlightedField === `section-${section.id}`
  const settings = section.settings || {}

  // Quote settings
  const quoteAuthor = settings.quoteAuthor || ""
  const rawPattern = (settings.backgroundPattern || "leaves").toLowerCase()
  const legacyToNew = { water: "ocean", pine: "evergreen", swoop: "wave" }
  const backgroundPattern = (legacyToNew[rawPattern] || rawPattern).toLowerCase()

  const palette = {
    textLight: theme?.colors?.textLight || "#FFFFFF",
    textDark: theme?.colors?.textDark || "#0b3954",
    primaryDark: theme?.colors?.primaryDark || "#8B6F6B",
    secondary: theme?.colors?.secondary || "#e9dfdc",
    bgDark: theme?.colors?.bgDark || "#efeae8"
  }

  // Get background pattern styles
  const getBackgroundPattern = () => {
    switch (backgroundPattern) {
      case "leaves":
        return { backgroundColor: palette.bgDark }
      case "ocean":
        return { backgroundColor: palette.bgDark }
      case "evergreen":
        return { backgroundColor: palette.bgDark }
      case "wave":
        return { backgroundColor: palette.bgDark }
      case "geometric":
        return { backgroundColor: palette.bgDark }
      default:
        return { backgroundColor: palette.bgDark }
    }
  }

  // Get background image for each pattern
  const getBackgroundImage = () => {
    switch (backgroundPattern) {
      case "leaves":
        return quoteLeavesBgMobile
      case "ocean":
        return quoteOceanBgMobile
      case "evergreen":
        return quoteEvergreenBgMobile
      case "wave":
        return quoteWaveBgMobile
      case "geometric":
        return quoteGeometricBgMobile
      default:
        return quoteLeavesBgMobile
    }
  }

  return (
    <section
      className={twMerge("relative overflow-hidden py-8 md:py-12", isHighlighted ? DEFAULT_HIGHLIGHT_CLASSES : "")}
      style={{
        ...getBackgroundPattern(),
        width: "100%"
      }}>
      {/* Background image from Figma design - preserving original transparencies */}
      <img
        src={getBackgroundImage()}
        alt=""
        aria-hidden
        className="cover pointer-events-none absolute inset-0 h-full w-full select-none bg-cover"
      />

      <AnimatedSection className="relative z-10 mx-auto max-w-6xl px-5 md:px-4">
        <div className="flex h-[276px] items-center justify-center text-center">
          <div className="max-w-4xl">
            {/* Quote Text */}
            <blockquote
              className="mb-4 text-[20px] font-medium leading-[28px] xl:text-4xl lg:text-5xl md:mb-6 md:text-3xl md:leading-relaxed"
              style={{
                fontFamily: theme?.fonts?.heading || "serif",
                fontWeight: theme?.fonts?.headingWeight || "700",
                color: palette.textLight
              }}>
              &quot;{section.body || "Your quote text will appear here..."}&quot;
            </blockquote>

            {/* Quote Author */}
            {quoteAuthor && (
              <div
                className="text-[16px] font-semibold leading-[22px] lg:text-2xl md:text-xl"
                style={{
                  fontFamily: theme?.fonts?.paragraph || "sans-serif",
                  fontWeight: theme?.fonts?.paragraphRegularWeight || "400",
                  color: palette.textLight
                }}>
                — {quoteAuthor}
              </div>
            )}
          </div>
        </div>
      </AnimatedSection>
    </section>
  )
}

export default QuoteSectionMobile
